import React, { createContext, useState, useContext, useEffect } from 'react';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [customer, setCustomer] = useState(() => {
    const saved = localStorage.getItem('customer');
    return saved ? JSON.parse(saved) : null;
  });
  const [loyaltyAccount, setLoyaltyAccount] = useState(() => {
    const saved = localStorage.getItem('loyaltyAccount');
    return saved ? JSON.parse(saved) : null;
  });

  useEffect(() => {
    if (customer) {
      localStorage.setItem('customer', JSON.stringify(customer));
    } else {
      localStorage.removeItem('customer');
    }
  }, [customer]);

  useEffect(() => {
    if (loyaltyAccount) {
      localStorage.setItem('loyaltyAccount', JSON.stringify(loyaltyAccount));
    } else {
      localStorage.removeItem('loyaltyAccount');
    }
  }, [loyaltyAccount]);

  const login = (customerData, loyaltyData = null) => {
    setCustomer(customerData);
    setLoyaltyAccount(loyaltyData);
  };

  const logout = () => {
    setCustomer(null);
    setLoyaltyAccount(null);
  };

  const isLoggedIn = !!customer;

  const value = {
    customer,
    loyaltyAccount,
    isLoggedIn,
    login,
    logout,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserContext;
